var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "half-star_svg__a",
    x1: -157.8,
    x2: -137.8,
    y1: 101.8,
    y2: 101.8,
    gradientTransform: "matrix(1.2 0 0 -1.2 189.4 136.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fc02f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3fc02f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3fc02f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#219653",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28.8v28.8H0z",
    style: {
      fill: "url(#half-star_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2 14 5.2-4H14l-2-6.4-2 6.4H3.6l5.2 4-2 6.3 5.2-3.9 5.2 4z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgHalfStar;